"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.draggingElement = exports.reorderItems = exports.focusDragHandle = void 0;
// Force focus on the current dragged elements draghandle
const focusDragHandle = (id, action) => {
    const thisElementDragHandle = document.querySelector(`.btn-drag-handle[data-rbd-drag-handle-draggable-id="${id}"]`);
    if (action === 'focus') {
        thisElementDragHandle?.focus();
    }
    else {
        thisElementDragHandle?.blur();
    }
};
exports.focusDragHandle = focusDragHandle;
// Reorder items
const reorderItems = (result, items) => {
    // dropped outside the list, nothing happens, so no reorder needed
    if (!result.destination) {
        return;
    }
    const startIndex = result.source.index;
    const endIndex = result.destination ? result.destination.index : startIndex;
    const thisElementData = items[startIndex];
    // Use the rjsf function to reorder the items
    thisElementData.onReorderClick(startIndex, endIndex)();
};
exports.reorderItems = reorderItems;
// Dragging function for ArrayOfObjects
// Function for toggling styling of dragged element
const draggingElement = (dragId, action) => {
    const dragSelector = `[data-rbd-draggable-id="${dragId}"]`;
    const dragItem = document.querySelector(dragSelector);
    if (action === 'add') {
        dragItem.classList.add('is-dragging');
    }
    else {
        dragItem.classList.remove('is-dragging');
    }
};
exports.draggingElement = draggingElement;
